<template>
  <div class="info-panel__item">
    <slot></slot>
  </div>
</template>
